import { createContext, useContext } from "react";

const CurrentTeamIdContext = createContext<string | undefined>(undefined);

export const CurrentTeamIdProvider = CurrentTeamIdContext.Provider;

export function useCurrentTeamId() {
  return useContext(CurrentTeamIdContext);
}
